import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Form } from "react-bootstrap";

function OBCustomCheckBoxButton({
  id,
  name,
  value,
  checked,
  onChange,
  icon,
  text1,
  text2,
  tooltipText,
}) {
  return (
    <div
      onClick={(e) => {
        if (e.target.tagName !== "INPUT") {
          e.preventDefault();
          onChange({ target: { checked: !checked, value } });
        }
      }}
      data-tooltip-id={`ob-sup-type-custom-checkbox-tooltip-${id}`}
      className={`d-flex align-items-center ps-3 pe-3  mb-3 gap-1 ob-supplier-radio-item`}
    >
      <Form.Check
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={"radio-button"}
      />
      <div
        className={`d-flex align-items-center ob-supplier-radio-item-wrapper`}
      >
        <div className={"ob-supplier-radio-item-icon"}>
          <img src={icon} alt="icon" width={25} height={25} />
        </div>
        <div className={"ob-supplier-radio-item-text-container"}>
          <p className={"m-0 ob-supplier-radio-item-text1"}>{text1}</p>
          <p
            className={"m-0 ob-supplier-radio-item-text2"}
            dangerouslySetInnerHTML={{ __html: text2 }}
          ></p>
        </div>
      </div>
      {/* <ReactTooltip
        id={`ob-sup-type-custom-checkbox-tooltip-${id}`}
        className="tooltip"
        place="right"
        content={() => <div>{tooltipText}</div>}
      /> */}
    </div>
  );
}

export default OBCustomCheckBoxButton;
